/**
 * 部门名**单一来源**(2026-07-24 F1-b 提取)。
 *
 * ★为什么要单独一处:同一个部门此前在三个地方各写一次 —— 工作台部门卡 `DEPT_ENTRIES.title`
 * (「创意设计中心」)、hub 页头 `<PageHeader title>`(「创意设计中心」)、侧栏
 * (「AI海报」)。前两处凑巧一致、第三处不一致,而**没有任何东西拦着它们漂**。
 * F3 侧栏 IA 要把三处统一,统一的前提是先有一个「一处」。
 *
 * `MODULE_LABEL`(shared/lib/moduleLabel)不删也不改:它是**模块**名(计费/权限/后端 catalog
 * 的显示名),与**部门**名是两件事 —— 部门卡副标就同时用了两者(「创意设计中心 / AI海报 · 14 个场景」)。
 */
// ★2026-07-24 营销智脑 IA:部门名换成「结果动词舱」命名(视觉舱 / 视频舱 / 分身舱 / 追爆舱 / 官媒舱)。
// moduleKey / 路由 / 计费全不动,只换显示名 —— 改这一处,侧栏 / hub 页头 / 部门卡 / 作品卡四处一起变。
export const DEPT_TITLE = {
  poster: "视觉舱",
  video: "视频舱",
  dh: "分身舱",
  explosive: "追爆舱",
  /**
   * 新闻舱(原「官媒舱」;2026-07-31 卡墙改版改名)。
   *
   * ★改名的**理由不是嫌旧名不好**:获客推广群同期新增了一张真叫「官媒舱」的即将卡
   * (官方媒体渠道投放),两张卡不能同名。这个舱的产物是新闻稿 / 软文 / 笔记,
   * 叫「新闻舱」比「官媒舱」更贴它实际在做的事,名字就让给新卡。
   * moduleKey(ai_reporter)/ 路由(/ai-jizhe)/ 计费全不动 —— 只换显示名。
   */
  jizhe: "新闻舱",
} as const;

/**
 * 「把产物送去新闻舱出稿」这个**目的地**的统一叫法(E2E 0810 EXP-RPT-04)。
 *
 * ★同一个去处此前三处三名:追爆目的地墙叫「新闻舱成稿」、蓝图卡菜单/抽屉按钮叫「官媒软文」
 * (舱改名前的旧词)、雷达计划卡叫「送新闻舱成稿」—— 用户在三个入口看到三个名字,
 * 认不出是同一件事。与 DEPT_TITLE 同理:先有一个「一处」,漂移才拦得住。
 * 从 DEPT_TITLE.jizhe 拼出来,舱名再改时这里自动跟着变。
 */
export const REPORTER_DEST_LABEL = `${DEPT_TITLE.jizhe}成稿`;

/**
 * 部门名 i18n key(F3 补债:DEPT_TITLE 此前纯中文,英文 locale 全中文)。
 * 有 `t` 的渲染点用 `t(DEPT_TITLE_KEY.x)`;纯数据投影点(mappers lineLabel)回退 DEPT_TITLE 中文。
 */
export const DEPT_TITLE_KEY = {
  poster: "dept.poster",
  video: "dept.video",
  dh: "dept.dh",
  explosive: "dept.explosive",
  jizhe: "dept.reporter",
} as const;

/** moduleKey → 部门名(权限门用 moduleKey,展示用部门名,两边要能对上)。 */
export const DEPT_TITLE_BY_MODULE: Record<string, string> = {
  ai_poster: DEPT_TITLE.poster,
  ai_video: DEPT_TITLE.video,
  ai_digital_human: DEPT_TITLE.dh,
  ai_explosive_parse: DEPT_TITLE.explosive,
  ai_reporter: DEPT_TITLE.jizhe,
};

/**
 * moduleKey → 部门名 i18n key。`DEPT_TITLE_BY_MODULE` 的可翻译版本。
 *
 * ★2026-08-08 补:平台侧套餐配置面此前用后端 `catalog.display_name`(「AI海报」「AI记者」),
 * 租户首页用这里的舱名(「视觉舱」「新闻舱」)—— 同一个舱两个名,超管勾的和租户看到的对不上。
 * 套餐面改读这份 key 后两边同名(见 features/billing/lib/cabinName)。
 */
export const DEPT_TITLE_KEY_BY_MODULE: Record<string, string> = {
  ai_poster: DEPT_TITLE_KEY.poster,
  ai_video: DEPT_TITLE_KEY.video,
  ai_digital_human: DEPT_TITLE_KEY.dh,
  ai_explosive_parse: DEPT_TITLE_KEY.explosive,
  ai_reporter: DEPT_TITLE_KEY.jizhe,
};
